var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAreaLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13.3643mm",
    height: "13.031876mm",
    viewBox: "0 0 13.3643 13.031876",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-386.79493,-296.58741)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2",
    transform: "matrix(1.6975572,0,0,1.6975572,-212.69053,-156.22253)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4",
    transform: "translate(104.70342,51.632362)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3-4",
    transform: "matrix(0.12706229,0,0,0.12706229,248.44255,215.10971)",
    style: {
      fill: "#642754",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1029-1",
    "data-name": "Tracciato 1029",
    d: "M 17.332,0 0.6,15.245 0,37.689 8.445,55.463 29.918,60.418 50.809,51.118 61.959,30.234 52.808,4.672 28.111,0.139 Z",
    fill: "#71ac9e",
    style: {
      fill: "#642754",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "UI_Select_arrow-6-6",
    d: "m 250.08295,218.82939 2.19209,2.48752 -0.13748,-1.77048 1.89503,0.54386 -0.15818,-2.44801 -1.8133,0.52451 0.17435,-1.83178 z",
    fill: "#59194b",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.12021
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreaLeft);
export default __webpack_public_path__ + "static/media/AreaLeft.940b9322ca778be8af278a147e60ed81.svg";
export { ForwardRef as ReactComponent };